export default __webpack_public_path__ + "assets/planetary_radio.28faa744.png";